import Link from 'next/link';
import RecentJobs from '../blog/blog-home/recent-jobs';

const NewJobPostings = () => {
  return (
    <>
      <p className="mb-3 text-white">New Job Postings</p>
      <RecentJobs number={3} />
      <Link href="/job-search" passHref>
        <a className="text-btn outline">Advanced Search </a>
      </Link>
    </>
  );
};

export default NewJobPostings;
